import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  width: 100%;
  max-width: 778px;
  margin: 0 auto;
  padding: 0 20px;
`;
